import makeApiCall from "../master/axiosIndex";
const STATIC_FILES_DATA = [
  {
    order: 0,
    module: "Work Request",
    moduleFileType: "signature.png",
  }
];

const workRequestApis = {
  getWorkRequestList: (params: any) =>
    makeApiCall({
      url: `/work-request/list`,
      method: "get",
      params,
    }),
  getPendingApprovalsWorkRequest: (params: any) =>
    makeApiCall({
      url: `/work-request/pending-approvals`,
      method: "get",
      params,
    }),
  getWorkRequestById: (workRequestId: any) =>
    makeApiCall({
      url: `/work-request/id/${workRequestId}`,
      method: "get",
    }),
  createWorkRequest: (data: any) =>
    makeApiCall({
      url: `/work-request/create`,
      method: "post",
      data,
    }),
  updateWorkRequest: (data: any) =>
    makeApiCall({
      url: `/work-request/update`,
      method: "put",
      data,
    }),

  workRequestApprovalAction: (approvalData: any, files: File[] = []): Promise<any> => {
    const formData = new FormData();
    const filesDataArray = Array.isArray(STATIC_FILES_DATA) ? STATIC_FILES_DATA : [STATIC_FILES_DATA];

    const approvalPayload = {
      ...approvalData,
      filesData: filesDataArray,
    };

    formData.append("workRequestApproval", JSON.stringify(approvalPayload));

    files.forEach((file) => {
      formData.append("files", file);
    });

    return makeApiCall<any>({
      method: "post",
      url: `/work-request/approve`,
      data: formData,
    });
  },

  taskListByActivityId: (params: any) =>
    makeApiCall({
      url: `/task/list`,
      method: "get",
      params,
    }),
};

export default workRequestApis;
